const africaCitiesOverview = [
  {
      "city": "Cape Town",
      "country": "South Africa",
      "price": "5200"
  },
  {
      "city": "Hermanus",
      "country": "South Africa",
      "price": "2200"
  },
  {
      "city": "Plettenberg Bay",
      "country": "South Africa",
      "price": "2200"
  },
  {
      "city": "Marrakech",
      "country": "Morocco",
      "price": "2000"
  },
  {
      "city": "Umhlanga",
      "country": "South Africa",
      "price": "2000"
  },
  {
      "city": "Central Sandton",
      "country": "South Africa",
      "price": "1800"
  },
  {
      "city": "Tangier",
      "country": "Morocco",
      "price": "1600"
  },
  {
      "city": "Casablanca",
      "country": "Morocco",
      "price": "1200"
  },
  {
      "city": "Cairo",
      "country": "Egypt",
      "price": "1200"
  },
  {
      "city": "Nairobi",
      "country": "Kenya",
      "price": "1200"
  }
];


export {africaCitiesOverview};